import React from 'react';
import { ModalType } from '../Modal';
import Loader from '../common/Loader';

const PlayListItem = ({
  handleOpenModal,
  item,
  index,
  isLoadingAudio,
  isFav,
  isPlaying,
  currentSelected,
  currentPlaying,
  activeDropDownIndex,
  isListItemDropdownOpen,
  onSelectChapterClick,
  onToggleListItemDropdown,
  handlePlayPause,
  onToggleFav,
  thumbnailImgSrc
}) => {
  return (
    <div
      className={
        currentSelected.order === item.order
          ? 'play-list-item selected is-active-playing'
          : `play-list-item ${
              currentPlaying.order === item.order ? ' is-active-playing' : ''
            }`
      }
      onClick={() => {
        // onSelectChapterClick(item);
        handlePlayPause(item);
      }}
    >
      <a id={index} className="anchor" />

      {
        /*!isLoadingAudio && currentPlaying.order === item.order ? */
        <div className={`play-btn-container ${isFav ? ' fav-active' : ' '}  `}>
          <div
            className={`is-flex is-align-items-center  is-justify-content-center play-btn
         ${currentPlaying.order === item.order ? ' is-active' : ''}`}
            onClick={e => {
              handlePlayPause(item);
              e.stopPropagation();
            }}
          >
            <div
              className={
                isPlaying && currentPlaying.order === item.order
                  ? 'icon play'
                  : 'icon pause'
              }
            >
              {/*${
            !isLoadingAudio ? ' disable-events' : ' '
          } */}
              {isLoadingAudio && currentPlaying.order === item.order ? (
                <span className="icon has-text-danger">
                  <i
                    className="fa fa-spinner fa-spin"
                    aria-hidden="true"
                    style={{ fontSize: '2rem', color: 'white' }}
                  />
                </span>
              ) : (
                <figure className="image ">
                  <img
                    className={
                      isPlaying && currentPlaying.order === item.order
                        ? 'is-rounded rotate-cd'
                        : 'is-rounded '
                    }
                    src={thumbnailImgSrc}
                  />
                </figure>
              )}
            </div>
          </div>
        </div>
      }

      <div className="play-list-item-content ">
        <p className="title-main ">
          <span> {item.name}</span>
        </p>
        <p className="title-sub">
          <span>{item.reciter}</span>
        </p>
      </div>
      <span className="order">{item.order}</span>
      <div
        className={
          index === activeDropDownIndex && isListItemDropdownOpen
            ? 'dropdown is-up is-active'
            : 'dropdown is-up'
        }
      >
        <div className="dropdown-trigger">
          <div className="options">
            <button
              onClick={ev => {
                onToggleListItemDropdown(index);

                ev.stopPropagation();
              }}
              className="button is-info is-outlined"
              id="dropdownTrig"
            >
              <span className="icon is-small">
                <i className="fa fa-th-list" />
              </span>
            </button>
          </div>
        </div>
        <div className="dropdown-menu" id="dropdown-menu" role="menu">
          <div className="dropdown-content">
            <a
              className="dropdown-item"
              onClick={() => {
                handlePlayPause(item);
                onToggleListItemDropdown(-1);

//here
              }}
            >
              {isPlaying && currentPlaying.order === item.order
                ? '  ايقاف السورة'
                : ' تشغيل السورة'}

              <span className="icon is-medium">
                <i
                  className={
                    isPlaying && currentPlaying.order === item.order
                      ? 'fa fa-pause-circle'
                      : 'fa fa-play-circle'
                  }
                />
              </span>
            </a>
            <a
              className="dropdown-item"
              onClick={ev => {
                onToggleFav(item);



                ev.stopPropagation();
              }}
            >
              {isFav ? 'حذف من المفضلة' : 'إضافة الى المفضلة'}
              <span className="icon is-medium">
                <i className={isFav ? 'fa fa-heart' : 'fa fa-heart-o'} />
              </span>
            </a>
            <a
              href={currentSelected.location}
              target="_blank"
              className="dropdown-item"
              onClick={ev => {
                console.log('download');
                onToggleListItemDropdown(-1);
                ev.stopPropagation();
              }}
            >
              تحميل السورة
              <span className="icon is-medium">
                <i className="fa fa-download" />
              </span>
            </a>
            <a
              className="dropdown-item"
              onClick={ev => {
                handleOpenModal(ModalType.CHAPTER_INFO, item);
                onToggleListItemDropdown(-1);
              


                ev.stopPropagation();
              }}
            >
              معلومات حول السورة
              <span className="icon is-medium">
                <i className="fa fa-question-circle" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayListItem;
